import React from 'react';
import { GetProps, YStack } from '@usepepper/sprout-kit-ui';

export const AlertCardSurface: React.FC<{
  children: GetProps<typeof YStack>['children'];
}> = ({ children }) => (
  <YStack
    backgroundColor="$bgPrimaryDefault"
    borderColor="$borderPrimary"
    borderRadius="$12"
    borderWidth={1}
    overflow="hidden"
  >
    {children}
  </YStack>
);
